export const SITE = {
  brand: "The Wee Nook",
  tagline: "Hair • Education • Empowerment",
  subtitle:
    "Helping women fall back in love with their hair while inspiring the next generation of hairstylists to build careers they truly love.",
  bookingUrl: "https://the-wee-nook.book.app",
  instagramUrl: "https://www.instagram.com/malekdridihairandbeauty",
  instagramHandle: "@malekdridihairandbeauty",
  tiktokUrl: "https://www.tiktok.com/@malekdridihairandbeauty",
  tiktokHandle: "@malekdridihairandbeauty",
  facebookUrl: "https://www.facebook.com/malekdridihairandbeauty",
  facebookHandle: "Malek Dridi Hair & Beauty",
  email: "hello@malekdridihairandbeauty.com",
  addressLine: "58 Love Street, Paisley, PA3 2DY, Scotland",
  addressLines: ["58 Love Street", "Paisley, PA3 2DY", "Scotland"],
  mapEmbed:
    "https://www.google.com/maps?q=58+Love+Street+Paisley+PA3+2DY&output=embed",
  mapDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=58+Love+Street+Paisley+PA3+2DY",
  travelNotes: [
    "5-minute walk from Paisley Gilmour Street train station",
    "Fully accessible",
    "Street parking available on Love Street & nearby side streets",
  ],
  hours: [
    { day: "Monday", time: "Closed (Training)" },
    { day: "Tuesday", time: "10:00 — 17:00" },
    { day: "Wednesday", time: "10:00 — 17:00" },
    { day: "Thursday", time: "10:00 — 20:00 (Late Night)" },
    { day: "Friday", time: "10:00 — 14:00" },
    { day: "Saturday", time: "Closed (Training)" },
    { day: "Sunday", time: "Closed (Training)" },
  ],
  bookingNote:
    "Appointments are available by online booking. New clients are encouraged to book a consultation before colour or hair extension services to allow for colour matching, hair assessment and choosing the most suitable extension method.",
  socials: [
    { label: "Instagram", href: "https://www.instagram.com/malekdridihairandbeauty" },
    { label: "Facebook", href: "https://www.facebook.com/malekdridihairandbeauty" },
    { label: "TikTok", href: "https://www.tiktok.com/@malekdridihairandbeauty" },
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Bridal", to: "/bridal" },
  { label: "Pamper Parties", to: "/pamper-parties" },
  { label: "Extensions", to: "/shop?category=Hair%20Extensions" },
  { label: "Hair Loss", to: "/hair-loss" },
  { label: "Academy", to: "/academy" },
  { label: "Free Education", to: "/free-education" },
  { label: "NøoksProRange", to: "/shop" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "About", to: "/about" },
  { label: "Trade Account", to: "/trade" },
  { label: "Contact", to: "/contact" },
];
